import { memo, useEffect } from "react";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";
import ".././inner.css";
import { LazyLoadImage } from "react-lazy-load-image-component";

function TreatmentPlanning() {
  useEffect(() => {
    document.title = "Personalized Treatment Planning | Viksha Health Care";
    const newMetaDescription =
      "Personalized treatment planning at Viksha Health Care for orthopaedic conditions. Get a tailored plan based on diagnosis, goals, and lifestyle.";
    const metaTag = document.querySelector('meta[name="description"]');
    if (metaTag) {
      metaTag.setAttribute("content", newMetaDescription);
    }
  }, []);

  return (
    <>
      <h2 style={{ fontSize: "0px" }}>Personalized Treatment Planning</h2>
      <div className="serinfobox">
        <div className="serinfoimg">
          <LazyLoadImage src="/photo/Personalized-Treatment-Planning.avif" />
        </div>
        <div className="textareaofser">
          <h1>Personalized Treatment Planning</h1>

          <p>
            Every orthopaedic condition is different, and so is every patient.
            Personalized treatment planning focuses on understanding your
            specific problem, lifestyle, and goals to create a care plan
            tailored to your needs.
          </p>

          <p>
            The aim is not only to relieve pain but also to restore function,
            improve mobility, and help you return to your daily activities
            safely and comfortably.
          </p>

          <h5>How Treatment Plans Are Developed</h5>

          <h6>Understanding Your Condition</h6>
          <p>
            After evaluation and diagnosis, the nature and severity of your
            condition are carefully explained. This helps you understand the
            available treatment options and what outcomes to expect.
          </p>

          <h6>Considering Your Lifestyle</h6>
          <p>
            Your occupation, daily activities, sports involvement, and overall
            health are taken into account. Treatment recommendations are
            adjusted to suit your physical demands and personal preferences.
          </p>

          <h6>Setting Recovery Goals</h6>
          <p>
            Clear and realistic recovery goals are discussed, such as reducing
            pain, improving joint movement, returning to work, or resuming
            sports and fitness activities.
          </p>

          <h5>Treatment Options May Include</h5>
          <ul>
            <li>Medications to reduce pain and inflammation</li>
            <li>Physiotherapy and structured exercise programs</li>
            <li>Supportive devices like braces or splints</li>
            <li>Injections for selected joint or soft tissue conditions</li>
            <li>
              Surgical procedures when non-surgical care is not sufficient
            </li>
          </ul>

          <h5>Step-by-Step Care Approach</h5>
          <p>
            Treatment often begins with the least invasive options. Conservative
            treatments are usually tried first, and more advanced procedures are
            considered only if symptoms do not improve or if the condition
            requires it.
          </p>

          <h5>Regular Monitoring and Adjustments</h5>
          <p>
            Recovery is monitored through follow-up visits. Treatment plans may
            be adjusted based on your progress, response to therapy, and any
            changes in symptoms. This ensures that care remains effective at
            every stage.
          </p>

          <h5>Education and Self-Care Guidance</h5>
          <p>
            Understanding your condition helps you manage it better. Guidance is
            provided on posture, safe movement, home exercises, and activity
            modifications to prevent further strain or injury.
          </p>

          <h5>Preventing Recurrence</h5>
          <p>
            A personalized plan also focuses on preventing future problems.
            Strengthening muscles, improving flexibility, and correcting
            movement patterns can reduce the chance of re-injury.
          </p>

          <h5>Your Role in Treatment Success</h5>
          <p>
            Active participation is an important part of recovery. Following
            exercise advice, attending physiotherapy sessions, and making
            recommended lifestyle changes can greatly improve outcomes.
          </p>

          <h5>Benefits of Personalized Planning</h5>
          <ul>
            <li>More effective pain relief</li>
            <li>Faster and safer recovery</li>
            <li>Reduced risk of complications</li>
            <li>Improved long-term joint and muscle health</li>
            <li>Treatment that fits your daily routine and goals</li>
          </ul>

          <p>
            A personalized treatment plan ensures that care is focused on what
            matters most to you — helping you move better, feel stronger, and
            return to your normal routine with confidence.
          </p>
        </div>
      </div>
    </>
  );
}

export default memo(TreatmentPlanning);
